import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../../shared/RouteProps';
import type { SalariesModel } from './salariesModel';

export const salariesLoader =
  (_args: RouteProps): LoaderFunction =>
  async (_args): Promise<SalariesModel> => {
    return {
      test: 'this is a temp content setup for salaries page',
    };
  };
